<mat-expansion-panel hideToggle [style.display]="visible ? 'block' : 'none'" [expanded]="expanded">
    <mat-expansion-panel-header (click)="onHeaderClick()">
        <mat-panel-title [id]="titleId || null">
            <mat-icon *ngIf="svgIcon; else fontIcon" [svgIcon]="svgIcon"></mat-icon>
            <ng-template #fontIcon>
                <mat-icon>{{ icon }}</mat-icon>
            </ng-template>
            <div class="menu-title">{{ title }}</div>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-content select="[section-pre]"></ng-content>

    <div class="menu-section-list">
        <ng-container *ngIf="items?.length; else projectedContent">
            <ng-container *ngFor="let item of items; trackBy: trackByMenuItemId">
                <hr *ngIf="item.isSeparator && item.visible !== false" class="menu-separator" />
                <app-menu-item *ngIf="!item.isSeparator" [id]="item.id" [label]="item.label"
                    [visible]="item.visible !== false" [hidden]="item.hidden" [disabled]="item.disabled"
                    [selected]="selectedItemId === item.id" [href]="item.href || null" [target]="item.target || null"
                    [showLaunchIcon]="item.showLaunchIcon || false" (itemClick)="menuItemClick.emit(item)"
                    (externalClick)="menuExternalClick.emit($event)"></app-menu-item>
            </ng-container>
        </ng-container>

        <ng-template #projectedContent>
            <ng-content></ng-content>
        </ng-template>
    </div>
</mat-expansion-panel>